
export default {
  name: 'OrganismRequestOfferModal'
}
